import { Card } from '@/components/ui/card'
import AuthLayout from '../auth-layout'
import { UserAuthForm } from './components/user-auth-form'

export default function SignIn() {
  return (
    <AuthLayout>
      <Card className='p-6'>
        <div className='flex flex-col space-y-2 text-left'>
          <h1 className='text-2xl font-semibold tracking-tight'>Đăng nhập</h1>
          <p className='text-sm text-muted-foreground'>
          Nhập email và mật khẩu của bạn bên dưới <br />
          để đăng nhập vào tài khoản của bạn
          </p>
        </div>
        <div className='mt-4'>
          <UserAuthForm />
        </div>
        <p className='mt-4 text-center text-xs text-muted-foreground'>
          Phiên đăng nhập dùng cookie HTTP-only.
        </p>
      </Card>
    </AuthLayout>
  )
}
